import "./Firstcom.css";

const FirstcomTheme = () => <></>;

export default FirstcomTheme;